module.exports = __webpack_public_path__ + "assets/media/xc.a870a146.mp4";